<template>
  <check-base-layout
    :pagetitle="pagetitle"
  >
    <template>
      <div>
        <customer-module :customer-data="checkFrom.customerAccountCreditVo"></customer-module>
      </div>
      <check-module :title="`客户余额`">
        <el-row>
          <el-col :span="8">
            <div>可用余额：{{checkFrom.accountBalance | toFixed}}</div>
<!--            .useBalance-->
          </el-col>
          <el-col :span="8">
            <div>账户余额：{{checkFrom.accountBalance | toFixed}}</div>
          </el-col>
        </el-row>
      </check-module>
      <check-module :title="`申请信息`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">申请人：{{checkFrom.createUser}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">申请时间：{{checkFrom.createDate | formatData}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">所属部门：{{checkFrom.orgName}}</div>
            </el-col>
          </el-row>
          <el-row>
            <slot name="beforeRemark"></slot>
            <el-col :span="8">
              <div class="">类型：{{balanceTypeState[checkFrom.balanceType]}}</div>
            </el-col>
            <el-col :span="8">
              <div class="">调整金额：{{checkFrom.newValue > 0 ? ('+' + checkFrom.newValue) : checkFrom.newValue}}</div>
            </el-col>
            <el-col :span="8">
              <div class="">备注：{{checkFrom.exPlain}}</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
    </template>
    <template #checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { balanceTypeState } from '@/meun/date'
export default {
  name: 'customerbalanadjustCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '客户余额调整审批'
    }
  },
  data () {
    return {
      balanceTypeState
    }
  },
  created () {
    this.getCustomerbalanadjustCheckInfo()
  },
  methods: {
    getCustomerbalanadjustCheckInfo () {
      const {
        snaId
      } = this
      checkApi.getCustomerbalanadjustCheckInfo({
        snaId
      }).then(res => {
        if (this.isSuccess(res)) {
          this.checkFrom = res.data.obj
          this.$emit('update:data', res.data.obj)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
